import React from 'react';
import S from './LegalLinks.styles';
const LegalLinks = ({ items }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.List, null, items.map((item) => (React.createElement(S.Item, { key: item.id },
            React.createElement(S.Link, { href: item.url, target: item.target, "aria-label": item.accessibleText }, item.text)))))));
};
export default LegalLinks;
